import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
    const { loading, isAuthenticated, user } = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '18px',
                color: '#bc965e'
            }}>
                Loading...
            </div>
        );
    }

    // If user is authenticated, redirect them to their appropriate dashboard
    // They should only access public routes after logging out
    if (isAuthenticated && user) {
        if (user.role === 'Admin') {
            return <Navigate to="/admin/dashboard" replace />;
        } else {
            return <Navigate to="/" replace />;
        }
    }

    // Public routes are only accessible to unauthenticated users
    return children;
};

export default PublicRoute;